import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/diia';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            mode: 'info',
            where_by: ['path'],
            search_by: ['/cards/diia'],
            widgets: [],
            where_by_2: ['path'],
            search_by_2: ['/cards/diia_veteransport'],
            widgets_2: [],
            loader: true
        };
        this.widgetsHelper = widgetsHelper;
    }

    scrollToBookOrSport() {
        const params = new URLSearchParams(window.location.search);

        const waitForElement = id => {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({block: 'start', behavior: 'smooth'});
            } else {
                requestAnimationFrame(() => waitForElement(id));
            }
        };

        if (params.has('ebook')) {
            waitForElement('ebook');
        }
        if (params.has('esport')) {
            waitForElement('esport');
        }
    }

    removeAnchorFromUrl() {
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
        this.widgetsHelper.getWidgets_2.call(this);
        const waitForDOM = () => {
            if (document.getElementById('233')) {
                this.scrollToCalcBtn();
            } else {
                requestAnimationFrame(waitForDOM);
            }
        };

        requestAnimationFrame(waitForDOM);

        this.scrollToBookOrSport();
    }

    componentWillUnmount() {
        this.removeAnchorFromUrl();
    }

    scrollToCalcBtn() {
        const currentURL = window.location.href;
        if (currentURL.includes('question_12')) {
            this.setState({mode: 'questions'}, () => {
                const targetElement = document.getElementById('233');
                if (targetElement) {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        }
    }

    toggleMode = mode => {
        this.setState({mode: mode});
    };
}
